export default __webpack_public_path__ + "static/media/gallery_02.709eb5a3.jpg";